import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import AuthService from 'cio/services/auth';
import AccountService from 'cio/services/account';
import AnalyticsService from 'cio/services/analytics';
import { action } from '@ember/object';
import { bool } from '@ember/object/computed';
import { PlanFeatures } from 'cio/models/account';

export default class IndexController extends Controller {
  @service auth!: AuthService;
  @service account!: AccountService;
  @service analytics!: AnalyticsService;

  @bool('account.current.suspendTrialAt') isEssentialsTrial!: boolean;

  get hasPlanLimit() {
    return this.account.planFeatures.workspaces.limit !== false;
  }

  get hasReachedPlanLimit() {
    return this.account.planLimitReached(PlanFeatures.Workspaces);
  }

  get cannotModifyWorkspaces() {
    return !this.auth.hasPermission('account/workspaces/create');
  }

  @action
  trackWorkspacesComparePlansClicked() {
    this.analytics.track('workspace', 'compare_plans_from_workspaces_viewed', { type: 'compare plans' });
  }
}
